import React from "react";
import { PropTypes } from "prop-types";
import { MrbPage, MrbPageHeader } from "mrb/components/layout";
import { MrbContentLoader } from "mrb/components/loader";
import { defaultTemplate } from "common/hoc";
import { UserEditLoader } from "administration/user/components";

import {
    UserProfilePasswordChange,
    UserProfileGeneralInfo,
    UserCertifiedModeInfoModal,
} from "application/user-settings/components";
import { ChangePasswordLoader, ToggleActionsLoader } from "common/components";
import { MrbSelect } from "mrb/components/select";
import { MrbToggle } from "mrb/components/checkbox";

function UserProfileEditTemplate({ userProfileEditViewStore, t }) {
    const {
        loaderStore,
        routeStore,
        shouldDisplayContentModeOptions,
        modeSelectStore,
        certifiedModeInfoModal,
        openCertifiedModeInfoModal,
        isTrendingHidden,
        updateHideTrending,
    } = userProfileEditViewStore;

    return (
        <MrbPage store={userProfileEditViewStore} t={t} contentClassNameExtend="c-container">
            <MrbPageHeader>
                <div className="c-page__header--top">
                    <div>{t("APPLICATION.USER_SETTINGS.EDIT.FIELDS.TITLE")}</div>
                </div>
            </MrbPageHeader>
            <div className="c-container--sidebar c-container--sidebar--med u-padd--none">
                <div>
                    <h2 className="u-type--base u-mar--bottom--sml">Personal Details</h2>
                    <div className="c-card--primary u-mar--bottom--sml">
                        <MrbContentLoader
                            loaderStore={loaderStore}
                            loaderRender={() => <UserEditLoader button={true} />}
                        >
                            {() => <UserProfileGeneralInfo userProfileEditViewStore={userProfileEditViewStore} />}
                        </MrbContentLoader>
                    </div>
                    {shouldDisplayContentModeOptions && (
                        <React.Fragment>
                            <h2 className="u-type--base u-mar--bottom--sml u-mar--top--sml">
                                {t("APPLICATION.USER_SETTINGS.EDIT.FIELDS.CERTIFIED_MODE.TITLE")}
                            </h2>
                            <div className="c-card--primary u-mar--bottom--sml">
                                <div className="u-display--flex u-display--flex--ai--center u-gap--sml">
                                    <MrbSelect
                                        classNameExtend="c-dropdown--dark c-dropdown--sml-custom"
                                        t={t}
                                        store={modeSelectStore}
                                    />
                                    <button
                                        type="button"
                                        style={{
                                            background: "none",
                                            border: "none",
                                            color: "#2e99ff",
                                            padding: 0,
                                            cursor: "pointer",
                                        }}
                                        onClick={openCertifiedModeInfoModal}
                                    >
                                        {t("APPLICATION.USER_SETTINGS.EDIT.FIELDS.CERTIFIED_MODE.INFO_BUTTON")}
                                    </button>
                                </div>
                            </div>
                        </React.Fragment>
                    )}
                    {/* Hide Trending is shown for all user types — no content-mode gate needed */}
                    <React.Fragment>
                        <h2 className="u-type--base u-mar--bottom--sml u-mar--top--sml">
                            {t("APPLICATION.USER_SETTINGS.EDIT.FIELDS.HIDE_TRENDING.TITLE")}
                        </h2>
                        <div className="c-card--primary u-mar--bottom--sml">
                            <MrbContentLoader
                                loaderStore={loaderStore}
                                loaderRender={() => <ToggleActionsLoader lineheight={25} rows={1} sidebarLrg />}
                            >
                                {() => (
                                    <div className="u-animation--fadeIn">
                                        <div className="c-sidebar__item">
                                            <div className="u-type--base">
                                                {t("APPLICATION.USER_SETTINGS.EDIT.FIELDS.HIDE_TRENDING.LABEL")}
                                            </div>
                                            <MrbToggle
                                                id="hideTrending"
                                                value={isTrendingHidden}
                                                onChange={(event) => {
                                                    event.preventDefault();
                                                    updateHideTrending(!isTrendingHidden);
                                                }}
                                            />
                                        </div>
                                    </div>
                                )}
                            </MrbContentLoader>
                        </div>
                    </React.Fragment>
                </div>

                <div>
                    <h2 className="u-type--base u-mar--bottom--sml">
                        {t("ADMINISTRATION.USER.PASSWORD_CHANGE.TITLE")}
                    </h2>
                    <div className="c-card--primary">
                        <MrbContentLoader loaderStore={loaderStore} loaderRender={() => <ChangePasswordLoader />}>
                            {() => <UserProfilePasswordChange componentProps={routeStore} />}
                        </MrbContentLoader>
                    </div>
                </div>
            </div>
            <UserCertifiedModeInfoModal modalParams={certifiedModeInfoModal} />
        </MrbPage>
    );
}

UserProfileEditTemplate.propTypes = {
    userProfileEditViewStore: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
};

export default defaultTemplate(UserProfileEditTemplate);
